import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    margin-bottom: 2.5rem;
    margin-top: 1.3rem;
    gap: 2rem;
    align-items: center;
`

export const CustomTextField = styled(TextFieldMui)`
    width: 18rem;    
    height: 2.5rem;
    margin: 0 !important;
`

export const CustomButton = styled(ButtonMui)`
    width: 16rem;    
    height: 2.5rem;
    margin: 0 !important;
`
